<template>
    <div class="mb-2 flex items-center pl-4">
      <div class="mr-2 flex w-[2%] max-w-[2%] justify-center">
        <BcCheckbox :id="`check_${processDate}`" :value="selected" class="is-uppercase font-size-s" @input="onChecked">
        </BcCheckbox>
      </div>
      <p class="text-xs capitalize text-blue-400">
        {{ formattedDate }}
      </p>
    </div>
  </template>
  
  <script lang="ts" setup>
    import { computed, defineProps, defineEmits } from 'vue';
    import moment from 'moment/min/moment-with-locales';
    import BcCheckbox from '@/ui-kit/components/BcCheckbox/BcCheckbox.vue';
  
    // Props
    const props = defineProps({
      processesByDate: {
        type: Object as () => { date: string },
        required: true,
      },
      selected: {
        type: Boolean,
        default: false,
      },
    });
  
    // Emits
    const emit = defineEmits(['checked:date']);
  
    // Computed property to format the date
    const formattedDate = computed(() => {
      return moment(props.processesByDate.date).format('dddd DD MMMM YYYY');
    });
  
    // Method to handle checkbox state change
    const onChecked = (checked: boolean) => {
      emit('checked:date', { checked, date: props.processesByDate });
    };
  
    // Get the date value from props
    const processDate = props.processesByDate.date;
  </script>
  
  <style scoped>
  /* Add your custom styles here */
  </style>
  